import { useEffect, useState } from "react";

/** The breakpoint App.css lays the dashboard detail pages out for a phone at. */
const PHONE_MEDIA_QUERY = "(max-width: 768px)";

/**
 * Whether the page is laid out for a phone right now — true at or under the
 * dashboard's phone breakpoint, tracking the window as it is resized — for
 * layouts the markup has to change for, not only the CSS.
 */
export default function useDashboardPhoneLayout() {
  const [isPhone, setIsPhone] = useState(
    () => typeof window !== "undefined" && window.matchMedia(PHONE_MEDIA_QUERY).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(PHONE_MEDIA_QUERY);
    const apply = () => setIsPhone(mq.matches);
    apply();
    mq.addEventListener("change", apply);
    return () => mq.removeEventListener("change", apply);
  }, []);

  return isPhone;
}
